"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
require("./styles.scss");
const SearchResultContainer = react_1.default.forwardRef(({ searchResultComponent, location, selectedHighlight, hoverHighlight, onClick, onKeyDown, onMouseEnter, onMouseLeave, showTopBorder, style, }, ref) => {
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.default)({
            searchresult: true,
            "searchresult-hovered": hoverHighlight,
            "searchresult-selected": selectedHighlight,
            "under-highlight": location.highlight,
        }), onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, tabIndex: 0, id: `sers-${location.id}`, ref: ref, style: style }, { children: [searchResultComponent, showTopBorder && (0, jsx_runtime_1.jsx)("div", { className: "top-border" })] })));
});
exports.default = SearchResultContainer;
